import Api from './rest/SpecQuoteFileApi';

export default new Api();
